/**
 * Create/update a instance to the database.
 * @param  {Object} options
 *         {string} options.endpoint
 *         {Object} options.data
 *         {string} options.data.className
 *         {number} options.data.[id] if the instance is being updated
 *         {string} options.method
 *         {string} options.remoteUrl
 * @returns {Promise}
 */
import { API_METHOD } from 'modules/api/constants'
import postApiService from 'modules/api/services/post'
import putApiService from 'modules/api/services/put'
import { getApiServiceUrlEnvironmentUtil } from 'modules/environment/utils'

async function saveReduxApi (options) {
  let {
    endpoint,
    data,
    method,
    remoteUrl
  } = options
  remoteUrl = remoteUrl || getApiServiceUrlEnvironmentUtil()
  const saveFn = (
    method === API_METHOD.POST
      ? postApiService
      : putApiService
  )
  const apiPath = `${remoteUrl}${endpoint}`
  const response = await saveFn(apiPath, data)
  if (response.data && Object.keys(response.data).length) {
    const extraData = response.data.extraData
    if (extraData) {
      delete response.data.extraData
    }
    const data = Object.values(response.data)[0] || {}
    return {
      data,
      extraData
    }
  }
  return {
    data: {}
  }
}

export default saveReduxApi
